export default __webpack_public_path__ + "static/media/skill12.836104e4.svg";